export interface LegDetailsProps {
	/** Formik Form ID */
	formId: string;
	/** Consignment entity we are on */
	consignmentId: number;
	/** Specific section that should automatically scroll into view on mount */
	scrollTo?: LegDetailsSubSection;
	/** Callback for when a Leg is selected from the Leg List */
	onLegSelect?: (legId: number | undefined) => void;
	/** Currently active Leg ID */
	activeLegId?: number | undefined;
}

export enum LegDetailsSubSection {
	Default,
	Container,
	Location,
	Notes
}
